function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.62,32c0,1.72-.88,3.31-2.33,4.19l-23.75,14.61c-.73.45-1.57.68-2.42.68-.82,0-1.62-.22-2.33-.63-1.49-.86-2.42-2.48-2.42-4.24v-29.22c0-2.69,2.13-4.87,4.75-4.87.85,0,1.69.24,2.42.68l23.75,14.61c1.44.88,2.33,2.47,2.33,4.19Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Play-Launch.ea5240a5.svg";
export { SvgComponent as ReactComponent };